import React from 'react';
import PropTypes from 'prop-types';

import RestoreIcon from '@mui/icons-material/Restore';
import { TableCell, TableRow } from '@mui/material';

import OnDeleteIcon from '../../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../../icons/OnEditIcon';
import OnWarningIcon from '../../../../icons/OnWarningIcon';
import { formatDate } from '../../../../utils/dateFunctions';

import table from '../../../../commonStyles/tables.module.css';
import tableRow from './bloodPressure.module.css';

const BloodPressureRow = ({
    row,
    isDisabled,
    isDeleteDisabled,
    onEdit,
    onDelete,
    isAuditable,
    onSearchAuditItems
}) => {
    return (
        <TableRow hover className={`${table.basicRowStripes}`}>
            <TableCell>{formatDate(row.eventDate)}</TableCell>
            <TableCell>
                <div>
                    <span className={tableRow.alignRow}>{row.systolic}</span>
                    {isAuditable && (
                        <span className={table.auditIcon}>
                            <RestoreIcon
                                onClick={(e) =>
                                    onSearchAuditItems(
                                        e,
                                        row.id,
                                        'Blood Pressure',
                                        'Systolic',
                                        'blood-pressure'
                                    )
                                }
                            />
                        </span>
                    )}
                </div>
            </TableCell>
            <TableCell>
                <div>
                    <span className={tableRow.alignRow}>{row.diastolic}</span>
                    {isAuditable && (
                        <span className={table.auditIcon}>
                            <RestoreIcon
                                onClick={(e) =>
                                    onSearchAuditItems(
                                        e,
                                        row.id,
                                        'Blood Pressure',
                                        'Diastolic',
                                        'blood-pressure'
                                    )
                                }
                            />
                        </span>
                    )}
                </div>
            </TableCell>
            <TableCell>{row.measurement}</TableCell>
            <TableCell>
                {row.isWarning && (
                    <span className={tableRow.alignRowIcon}>
                        <OnWarningIcon tooltipContent="Out of range value" />
                    </span>
                )}
            </TableCell>
            <TableCell align="right">
                <OnEditIcon onEdit={(e) => onEdit(e, row)} active={!isDisabled} />
            </TableCell>
            <TableCell align="right">
                <OnDeleteIcon onDelete={() => onDelete(row)} active={!isDeleteDisabled} />
            </TableCell>
        </TableRow>
    );
};

BloodPressureRow.propTypes = {
    row: PropTypes.object,
    isDisabled: PropTypes.bool,
    isDeleteDisabled: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    isAuditable: PropTypes.bool,
    onSearchAuditItems: PropTypes.func
};

export default BloodPressureRow;
